<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <el-form ref="formValidate" :model="model" :rules="rules" label-width="400px">
                    <el-form-item label="开始时间：" prop="start_time">
                        <el-date-picker v-model="model.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间：" prop="end_time">
                        <el-date-picker v-model="model.end_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>            
                    <el-button type="primary" @click="handleSubmit" size="medium" style="margin-left: 400px;margin-top:20px;margin-bottom:20px">执行导入</el-button>
                </el-form>
                <div class="dataBox" style="margin-top: 40px" v-if="resultList.length>0">
                    <el-table :data="resultList" border stripe max-height="600">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="work_type" label="作业类型"></el-table-column>
                        <el-table-column prop="unit_name" label="单元名称"></el-table-column>
                        <el-table-column prop="unit_code" label="单元编号"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号"></el-table-column>
                        <el-table-column prop="segment_no" label="段号"></el-table-column>
                        <el-table-column label="导入结果">
                            <template slot-scope="scope">
                                <span style="color: #67C23A" v-if="scope.row.result=='导入成功'">{{scope.row.result}}</span>
                                <span style="color: #F56C6C" v-else>{{scope.row.result}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { interfaceWorkReport } from "@/api/workreport";

export default {
    name: 'workreportInterface',
    data() {
        return {
            m_name: '接口导入作业报告',
            menu_id: 5990,
            resultList: [],
            model: {
                start_time: '',
                end_time: ''
            },
            rules: {
                start_time: [
                    {required: true, message: '开始时间不能为空', trigger: 'blur'},
                ],
                end_time: [
                    {required: true, message: '结束时间不能为空', trigger: 'blur'},
                ],
            },
            form_name: 'formValidate',
        };
    },
    methods: {
        handleSubmit(){
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在拉取接口数据',
                        background: 'rgba(255, 255, 255, 0.7)'
                    });
                    interfaceWorkReport(this.model.start_time, this.model.end_time).then(res=>{
                        loading.close();
                        if(res.code == 1){
                            this.resultList = res.data
                            this.$msgs("数据拉取完成")
                        }else {
                            this.resultList = res.data
                            this.$msg(res.msg)
                        }
                    })
                }
            })
        },
    }
};
</script>